import React from 'react';
import { connect } from 'react-redux';
import { demoProductList } from '../../Utils/demoData';
import style from './style.module.scss';
import ItemCell from '../ItemCell';
import { ItemTypes } from '../../Constants';

const ProductList = (props) => {
    return (
        <div className={style.productWrapper}>
            <div className={style.productCell}>
                {props.products.map((item, key) => <ItemCell itemType={ItemTypes.product} key={key} index={key} data={item} />)}
            </div>
        </div>
    )
}

export default connect((state) => {
    return {
        products: state.products
    }
})(ProductList);